import { useAnimateOnView } from '../../customHooks/useAnimateOnView';

import { fadeInUp } from './landing-motion';

const VideoIntroduction = () => {
  const { ref, visible } = useAnimateOnView();

  return (
    <section
      ref={ref}
      id="company"
      className="mt-[48px] px-[16px] md:mt-[72px] md:px-[56px]"
    >
      <div
        className={`relative bg-[rgba(247,249,252,1)] p-[12px] sm:p-[25px] pb-[0] ${
          visible ? fadeInUp : 'opacity-0'
        }`}
      >
        <img
          className="absolute left-0 top-0 z-10 h-auto w-[50px] sm:w-[100px] lg:w-[145px]"
          src="assets/video-sun.svg"
          alt=""
        />
        <img
          className="relative z-40"
          src="assets/video-introduction.svg"
          alt="video-introduction"
        />
      </div>
    </section>
  );
};

export default VideoIntroduction;
